import { useEffect, useState } from "react"
import { logoutUser } from "../../services/authenticationService"
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import { useNavigate } from "react-router-dom";

export function DashboardLogOff() {
    const [confirmationPopUp, setConfirmationPopUp] = useState(true);
    const navigate = useNavigate();
    async function logOut() {
        try {
            await logoutUser()
        } catch (error) {
          console.error("Error while Logging out:", error);
        }
      }

    return (
        <>
        <ConfirmationPopUp
        openConfirmModal={confirmationPopUp}
        message="Do you want to logout?"
        setOpenConfirmModal={() => {
          setConfirmationPopUp(false);
        }}
        successMethod={logOut}
        rejectMethod={() => { setConfirmationPopUp(false); navigate("/dashboard") }}
      />
        </>
    )
}
